import { render, staticRenderFns } from "./CreateCampaignCollectionFilters.vue?vue&type=template&id=01d1f21a&scoped=true"
import script from "./CreateCampaignCollectionFilters.vue?vue&type=script&lang=js"
export * from "./CreateCampaignCollectionFilters.vue?vue&type=script&lang=js"
import style0 from "./CreateCampaignCollectionFilters.vue?vue&type=style&index=0&id=01d1f21a&prod&lang=scss&scoped=true"
import style1 from "./CreateCampaignCollectionFilters.vue?vue&type=style&index=1&id=01d1f21a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d1f21a",
  null
  
)

export default component.exports